'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CwLabel = require('../cwlabel/CwLabel');

var _CwLabel2 = _interopRequireDefault(_CwLabel);

var _DayPicker = require('./DayPicker.scss');

var _DayPicker2 = _interopRequireDefault(_DayPicker);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Lays out the label for each day of the week as a single table row with 7 td elements
 */
var WeekDays = function WeekDays(props) {
  var days = props.daysOfTheWeek;
  var result = days.map(function (item, index) {
    return _react2.default.createElement(
      'td',
      { className: (0, _classnames2.default)(_DayPicker2.default.weekDays), key: item + index },
      _react2.default.createElement(
        _CwLabel2.default,
        null,
        item
      )
    );
  });
  return _react2.default.createElement(
    'tr',
    null,
    result
  );
};

WeekDays.propTypes = {
  /**
   * An array of localized days of the week
   */
  daysOfTheWeek: _propTypes2.default.array
};

WeekDays.defaultProps = {
  daysOfTheWeek: ["S", "M", "T", "W", "T", "F", "S"]
};

exports.default = WeekDays;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui/lib/components/cwdatepicker/WeekDays.js
// module id = 831
// module chunks = 10